import L from 'leaflet'
import { GestureHandling } from 'leaflet-gesture-handling';


export default class Maps {
  constructor(el) {
    this.el = el
    const container = el.querySelector('.maps--container')
    if (!container) return

    const lat = parseFloat(container.dataset.lat)
    const lng = parseFloat(container.dataset.lng)
    if (isNaN(lat) || isNaN(lng)) return

    const map = L.map(container, { gestureHandling: true, scrollWheelZoom: true }).setView([lat, lng], 14)

    L.tileLayer('https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_31zd_1_d766231b1140a438d696720d', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    }).addTo(map)
    

    const icon = L.divIcon({
      className: 'maps--marker',
      html: `<svg width="45" height="58" viewBox="0 0 45 58" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.9923 20.7364C44.6949 9.76911 35.3551 0.638925 23.7832 0.0335799C10.7714 -0.648092 0 9.13745 0 21.2996C0 25.1712 1.08964 28.7954 2.9993 31.9116L19.8304 56.6202C21.0841 58.4599 23.9277 58.4599 25.1814 56.6202L42.0014 31.9116C44.0027 28.6454 45.1035 24.8185 44.9923 20.7364ZM22.4962 31.6879C16.4169 31.6879 11.4941 27.0188 11.4941 21.2707C11.4941 15.5225 16.4169 10.8403 22.4962 10.8403C28.5754 10.8403 33.5038 15.5146 33.5038 21.2707C33.5038 27.0267 28.5809 31.6879 22.4962 31.6879Z" fill="#BE4227"/></svg>`,
      iconSize: [45, 58],
      iconAnchor: [22, 58],
    })

    L.marker([lat, lng], { icon }).addTo(map)

    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
  }
}
